(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-us"]) return;
  try {
    
  function applyHeaderWrapperScheme(header) {
    const headerWrapper = header?.querySelector('.header-wrapper');
    if (!headerWrapper) return;
    const schemeSolid = headerWrapper.getAttribute('data-color-scheme-solid');
    const schemeTransparent = headerWrapper.getAttribute('data-color-scheme-transparent');
    if (!schemeSolid || !schemeTransparent || schemeSolid === schemeTransparent) return;
    const useSolid =
      header.classList.contains('scrolled-past-header') || header.classList.contains('menu-open');
    const nextClass = useSolid ? schemeSolid : schemeTransparent;
    const prevClass = useSolid ? schemeTransparent : schemeSolid;
    headerWrapper.classList.remove(prevClass);
    if (!headerWrapper.classList.contains(nextClass)) {
      headerWrapper.classList.add(nextClass);
    }
  }

  function syncHeaderLogo(header) {
    const wrap = header?.querySelector('.header__heading-logo-wrapper[data-logo-url-dark]');
    if (!wrap) return;
    const img = wrap.querySelector('img.header__heading-logo');
    if (!img) return;

    function logoSrcMatches(url) {
      try {
        return new URL(img.currentSrc, window.location.href).href === new URL(url, window.location.href).href;
      } catch {
        return false;
      }
    }

    const useSolid =
      header.classList.contains('scrolled-past-header') || header.classList.contains('menu-open');
    const darkAtTop = wrap.dataset.darkAtTop === 'true';
    const darkWhenScrolled = wrap.dataset.darkWhenScrolled === 'true';
    const wantDark = useSolid ? darkWhenScrolled : darkAtTop;
    const nextKey = wantDark ? 'dark' : 'light';
    const prevKey = wrap.dataset.logoApplied;
    if (prevKey === nextKey) return;

    const nextUrl = wantDark ? wrap.dataset.logoUrlDark : wrap.dataset.logoUrlLight;
    if (logoSrcMatches(nextUrl)) {
      wrap.dataset.logoApplied = nextKey;
      return;
    }

    wrap.dataset.logoApplied = nextKey;
    img.removeAttribute('srcset');
    img.src = nextUrl;
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this.header.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.announcementBar = document.querySelectorAll('.announcement-bar-section');
      this.isTransparent = this.getAttribute('data-transparent') == 'true' || false;
      this.announcementViewHeight = 0;
      this.announcementBottom = 0;

      this.announcementBar.forEach(bar => {
        this.announcementViewHeight += bar.clientHeight;
        this.announcementBottom += bar.clientHeight;
      });

      this.updateAnnouncementViewHeight();

      if (this.isTransparent || this.isTransparent == 'true') {
        this.setTopSpace();
      }
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      requestAnimationFrame(() => {
        applyHeaderWrapperScheme(this.header);
        syncHeaderLogo(this.header);
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerWrapper.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let scrollUpCondition = scrollTop > this.headerBounds.bottom;
      let resetCondition = scrollTop <= this.headerBounds.top;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        scrollUpCondition = scrollTop > this.announcementBottom;
        resetCondition = scrollTop <= this.announcementBottom;
      }

      this.updateAnnouncementViewHeight();

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling down
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) {
          applyHeaderWrapperScheme(this.header);
          syncHeaderLogo(this.header);
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollUpCondition) {
        // Scrolling up
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          // Prevent reveal if user is scrolling up
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (resetCondition) {
        // Reset
        document.documentElement.style.setProperty('--header-top-space', `${Math.abs(this.announcementViewHeight)}px`);
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      applyHeaderWrapperScheme(this.header);
      syncHeaderLogo(this.header);
      this.currentScrollTop = scrollTop;
    }

    updateAnnouncementViewHeight() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const announcementBar = this.announcementBar;
      var announcementOffsetBottom = 0;

      this.announcementBar.forEach(bar => {
        announcementOffsetBottom += bar.clientHeight;
      });

      const announcementViewHeight = scrollTop - announcementOffsetBottom;

      this.announcementViewHeight = announcementViewHeight;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // Mega nav / menu drawer set .menu-open on the section; do not tear down disclosures
      // while an overlay menu is active (also covers preventHide races between header-menus).
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    setTopSpace() {
      document.documentElement.style.setProperty('--header-top-space', `${this.announcementBottom}px`);
    }
  }

  document.addEventListener('header:menu-open-change', () => {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;
    applyHeaderWrapperScheme(sectionHeader);
    syncHeaderLogo(sectionHeader);
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.announcementBar = document.querySelectorAll('.announcement-bar-section');
      this.isTransparent = this.getAttribute('data-transparent') == 'true' || false;
      this.announcementViewHeight = 0;
      this.announcementBottom = 0;

      this.announcementBar.forEach(bar => {
        this.announcementViewHeight += bar.clientHeight;
        this.announcementBottom += bar.clientHeight;
      });

      this.updateAnnouncementViewHeight();

      if (this.isTransparent || this.isTransparent == 'true') {
        this.setTopSpace();
      }
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let scrollUpCondition = scrollTop > this.headerBounds.bottom;
      let resetCondition = scrollTop <= this.headerBounds.top;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        scrollUpCondition = scrollTop > this.announcementBottom;
        resetCondition = scrollTop <= this.announcementBottom;
      }

      this.updateAnnouncementViewHeight();

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling down
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollUpCondition) {
        // Scrolling up
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          // Prevent reveal if user is scrolling up
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (resetCondition) {
        // Reset
        document.documentElement.style.setProperty('--header-top-space', `${Math.abs(this.announcementViewHeight)}px`);
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    updateAnnouncementViewHeight() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const announcementBar = this.announcementBar;
      var announcementOffsetBottom = 0;

      this.announcementBar.forEach(bar => {
        announcementOffsetBottom += bar.clientHeight;
      });

      const announcementViewHeight = scrollTop - announcementOffsetBottom;

      this.announcementViewHeight = announcementViewHeight;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    setTopSpace() {
      document.documentElement.style.setProperty('--header-top-space', `${this.announcementBottom}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
